import React, { useLayoutEffect, useRef, useState } from 'react';
import cn from 'classnames';

import { ITextClampProps } from './TextClamp.types';

import './TextClamp.scss';

const TextClamp: React.FC<ITextClampProps> = ({
	textName,
	text,
	clampedTextClassname,
	lineHeight = 20,
	isToggleButtonLeft,
	fontSize = 16,
}) => {
	const textRef = useRef<HTMLInputElement | null>(null);
	const [isFullTextVisible, setIsFullTextVisible] = useState(false);
	const [isFullSize, setIsFullSize] = useState(false);

	const getDimensions = () => {
		if (textRef.current) {
			const isFullSize = textRef.current?.offsetHeight <= lineHeight * 2;

			setIsFullSize(isFullSize);
		}
	};

	useLayoutEffect(() => {
		getDimensions();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [text, textRef.current]);

	const textClassname = cn('f5gTextClampWordBreak', {
		'f5gTextClampClamped': !isFullTextVisible && !isFullSize,
		[`${clampedTextClassname}`]: !isFullTextVisible,
	});

	const buttonClassname = cn('f5gTextClampToggleBtn', {
		'f5gTextClampToggleBtnLeft': isToggleButtonLeft,
	});

	const handleClick = () => setIsFullTextVisible(!isFullTextVisible);

	return (
		<div className='f5gTextClampContainer'>
			<div
				className='f5gTextClampTextContainer'
				style={{ fontSize: `${fontSize}px` }}
			>
				{textName
					&& <div className='f5gTextClampTextName'>
						{`${textName}:`}
					</div>
				}
				<div
					ref={textRef}
					className={textClassname}
				>
					{text}
				</div>
			</div>
			{!isFullSize
				&& <div
					className={buttonClassname}
					onClick={handleClick}
				>
					{isFullTextVisible ? 'Show less' : 'Show more'}
				</div>
			}
		</div>
	);
};

export default TextClamp;
